import HealthManagePane from "./HealthManagePane";

export default HealthManagePane;
export { HealthManagePane };
